
/*

 Textfields (with reset icon, adaptive placeholders etc)

 */

function textfield_init($o, context)
{
    if (typeof $o === "undefined") $o = $(".textfield");

    if (!$("body").hasClass("textfield-inited")) {

        $(document).on("keydown keyup focus blur textfield-filled", ".textfield", function (e) {
            var is_filled = !!$(this).val();
            $(this).toggleClass("filled", is_filled);
        });

        $("body").addClass("textfield-inited")
    }
    if (!$o) {
        $o = context?$('.textfield', context):$('.textfield');
    }
    $o.trigger("textfield-filled");
}



/*
Autosize Textarea
 */

function textfield_autosize_init($o, context)
{
    if (!$o) {
        $o = context?$('.js-autosize', context):$('.js-autosize');
    }
    $o.not(".js-autosize-inited").each(function(){
        autosize($(this));
        $(this).addClass("js-autosize-inited");
    });
}



/* Инпут-счетчик кол-ва */

function input_spin_init() {
    var $o = $('[data-trigger="spinner"]');
    var $o1 = $o.not('.input-spin-inited').spinner('changing', function(e, newVal, oldVal) {
    }).on('mouseleave.spinner', '[data-spin="up"], [data-spin="down"]', function(){
        var data = $(this).closest('[data-trigger="spinner"]').data('spinner');
        clearTimeout(data.spinTimeout);
        clearInterval(data.spinInterval);
    }).on('changing.spinner changing-spinner-init', function(){
        var $wrapper = $(this).closest('[data-trigger="spinner"]');
        var data = $wrapper.data('spinner');
        var val = data.spinning.$el.val();
        var suffix = data.spinning.$el.data('suffix');
        var clone_val = val + ((suffix)?suffix:'');
        $wrapper.find('[data-spin-clone]').html(clone_val).val(clone_val);
        $wrapper.find('[data-spin="down"]').toggleClass('active', val > data.spinning.min);
        $wrapper.find('[data-spin="up"]').toggleClass('active', val < data.spinning.max);
    }).addClass('input-spin-inited');

    $o.not('.js-number-format-spinner-inited').on('changing.spinner changing-spinner-init', function() {
        var $wrapper = $(this).closest('[data-trigger="spinner"]');
        var data = $wrapper.data('spinner');
        var val = data.spinning.$el.val();
        if ($().number) {
            val = $.number(val, 0, ",", " ");
        }
        var suffix = data.spinning.$el.data('suffix');
        var clone_val = val + ((suffix)?suffix:'');
        $(this).closest('[data-trigger="spinner"]').find('[data-spin-clone]').html(clone_val).val(clone_val);
    }).addClass('js-number-format-spinner-inited').find('.input-spin__value').on('keyup', function(e){
        if (e.which == 27 || e.which == 13){
            $(this).next().focus();
        }
    });

    $o1.trigger('changing-spinner-init');
}